import { Pipe, PipeTransform } from '@angular/core';
import { constants } from '@app/shared/utils/constants';

@Pipe({
  name: 'ticketLogDepartmentType',
  standalone: false,
})
export class TicketLogDepartmentTypePipe implements PipeTransform {
  transform(value?: string, args?: any): string | null {
    if (!value) {
      return null;
    }

    return constants.ticketcenter.ticketLogDepartmentTypes.find(tldt => tldt.value === value).label;
  }
}
